import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DialogService {

    private dialog = inject(MatDialog);

    async openDialog<T>(component: ComponentType<T>, config: MatDialogConfig<any> = null) {
        const dialogRef = this.dialog.open(component, {
            ...{
                height: '80%',
                width: '80%',
            },
            ...config,
        });

        return lastValueFrom(dialogRef.afterClosed());
    }

    close(): void {
        this.dialog.closeAll();
    }
}
